import React, { ReactChild } from 'react'
import { useToggleNavbarOnScroll } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'

export const AnimatedHeaderWrapper = ({
  children,
  categoryOutOfView,
  isDesktopNavOpened,
  handleMouseleave,
  reset,
  categoryRef,
  mainRef,
  toggleDesktopNav,
}: {
  children: ReactChild
  categoryOutOfView: boolean
  isDesktopNavOpened: boolean
  handleMouseleave: (
    allowedRef: React.RefObject<any>[],
    callback: () => any,
    disallowedRef: React.RefObject<any>
  ) => (event: any) => void
  active: string
  reset: () => void
  categoryRef: React.RefObject<any>
  mainRef: React.RefObject<any>
  toggleDesktopNav: (a: boolean) => () => void
}) => {
  const displayNavbar = useToggleNavbarOnScroll()

  const resetNav = () => {
    toggleDesktopNav(false)()
    reset()
  }

  const getTransform = () => {
    if (!categoryOutOfView) {
      return 'translateY(-12.25rem)'
    }

    if (isDesktopNavOpened) {
      return 'translateY(0)'
    }

    if (!displayNavbar) {
      return 'translateY(-12.25rem)'
    }

    return 'translateY(0)'
  }

  const style = {
    transform: getTransform(),
    transition: !categoryOutOfView
      ? 'none'
      : 'transform 0.6s cubic-bezier(.37,.06,.27,.83)',
  }

  return (
    <Animated
      style={style}
      onMouseLeave={handleMouseleave([categoryRef], resetNav, mainRef)}
    >
      <Container categoryOutOfView={categoryOutOfView}>
        <div className="container">{children}</div>
      </Container>
    </Animated>
  )
}

const Animated = styled.div`
  transform: translateY(-12.25rem);
  position: relative;
  z-index: 9999;
`

const Container = styled.div<{ categoryOutOfView?: boolean }>`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    padding-top: 2.4rem;
    padding-bottom: 2.4rem;
  }

  background: ${({ theme }) => theme.palette.secondary};
  border-bottom: ${(props) =>
    props.categoryOutOfView
      ? `0.2rem ${props.theme.palette.silverTree} solid`
      : '0'};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm.max}) {
    padding-top: 0.6rem;
    padding-bottom: 0.8rem;
    border-bottom: none;
  }
`
